import primitives from '@core-ds/primitives';

export default {
   body: primitives.fontFamily.sansSystem,
   heading: primitives.fontFamily.sansSystem,
   mono: primitives.fontFamily.monoSystem,
};
